import * as React from "react";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { NavLink as RouterLink, useParams } from "react-router-dom";
import { industryReportsSidebarLinks } from "../../utils/industryReportSidebarLinks";

function ListItemLink(props) {
    const { icon, primary, to, handleDrawerClose } = props;

    const renderLink = React.useMemo(
        () =>
            React.forwardRef(function Link(itemProps, ref) {
                return <RouterLink to={to} ref={ref} {...itemProps} role={undefined}
                    style={({ isActive }) => {
                        return {
                            textDecoration: "none",
                            color: isActive ? "DeepPink" : "inherit",
                        };
                    }}
                />;
            }),
        [to]
    );

    return (
        <li>
            <ListItemButton component={renderLink} onClick={handleDrawerClose}>
                {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                <ListItemText primary={primary} />
            </ListItemButton>
            <Divider />
        </li>
    );
}

ListItemLink.propTypes = {
    icon: PropTypes.element,
    primary: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
};

export default function IndustryReportMenuListItems({ handleDrawerClose }) {
    let params = useParams();
    const reportId = params.reportId;
    return (
        <Box>
            <List aria-label="industry report list">
                {industryReportsSidebarLinks.map((item) => (
                    <ListItemLink
                        key={`${item.title}`}
                        to={`/reports/${reportId}/${item.route}`}
                        primary={`${item.title}`}
                        handleDrawerClose={handleDrawerClose}
                    />
                ))}
            </List>
        </Box>
    );
}
